// src/components/EmployeeRegularize.js
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { EssDasbaord } from "../../../api/Ess/Essleaves";

// Validation Schema
const validationSchema = Yup.object({
  date: Yup.date().required("Date is required"),
  requestedIn: Yup.string().required("Requested In Time is required"),
  requestedOut: Yup.string().required("Requested Out Time is required"),
  remarks: Yup.string()
    // .min(5, "Remarks must be at least 5 characters")
    .required("Remarks are required"),
});

const EmployeeRegularize = () => {
  const user = JSON.parse(localStorage.getItem("school_user"));
  const school_id = user?.user_detail?.fk_school_id;
  const staff_id = user?.user_detail?.staff_id;
  const [activeTab, setActiveTab] = useState("application");
  const [prevApp, setPrevApp] = useState([]);

  const getAllApplication = async () => {
    const previousApplications = [
      {
        id: 1,
        date: "2025-08-04",
        requestedIn: "09:30 AM",
        requestedOut: "07:00 PM",
        status: "APPROVED",
        remarks: "Personal work in the morning",
      },
      {
        id: 2,
        date: "2025-08-01",
        requestedIn: "09:00 AM",
        requestedOut: "07:30 PM",
        status: "REJECTED",
        remarks: "Traffic delay",
      },
      {
        id: 3,
        date: "2025-07-28",
        requestedIn: "10:00 AM",
        requestedOut: "06:30 PM",
        status: "PENDING",
        remarks: "Doctor appointment",
      },
    ];
    const data = {
      school_id: school_id,
      staff_id: staff_id,
    };

    const response = await EssDasbaord.getStaffApplications(data);
    const res = response.data;
    if (res.status === 200) {
      // Handle successful response
      setPrevApp(res.data);
    }
    // setPrevApp(previousApplications)
  };

  useEffect(() => {
    getAllApplication();
  }, []);

  const getStatusBadge = (status) => {
    switch (status) {
      case "APPROVED":
        return <span className="badge bg-success">{status}</span>;
      case "REJECTED":
        return <span className="badge bg-danger">{status}</span>;
      case "PENDING":
        return <span className="badge bg-warning text-dark">{status}</span>;
      default:
        return <span className="badge bg-secondary">{status}</span>;
    }
  };

  return (
    <div className="container mt-4 leave-tabs-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0 fw-bold">Apply For Regularize</h4>
        <ul className="nav nav-tabs custom-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${
                activeTab === "application" ? "active" : ""
              }`}
              onClick={() => setActiveTab("application")}
            >
              Apply for Regularize
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "previous" ? "active" : ""}`}
              onClick={() => setActiveTab("previous")}
            >
              Previous Applications
            </button>
          </li>
        </ul>
      </div>

      {/* Application Form */}
      {activeTab === "application" && (
        <div className="card shadow-sm p-4">
          <Formik
            initialValues={{
              date: "",
              requestedIn: "",
              requestedOut: "",
              remarks: "",
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
              let data = {
                school_id: school_id,
                staff_id: staff_id,
                attendence_month: values.date.slice(0, 7),

                ...values,
              };

              try {
                const response =
                  await EssDasbaord.send_regularize_applicatoin(data);
                const res = response.data;
                if (res.status === 200) {
                  Swal.fire({
                    title: "Application Submitted",
                    text: "Your regularization request has been submitted successfully.",
                    icon: "success",
                  });
                  resetForm();
                } else {
                  Swal.fire({
                    title: "Submission Failed",
                    text: res?.msg || "Something went wrong.",
                    icon: "error",
                  });
                }
              } catch (error) {
                console.log(error);

                Swal.fire({
                  title: "Submission Failed",
                  text:
                    error?.response?.data?.msg ||
                    "There was an issue submitting your application.",
                  icon: "error",
                });
              }
            }}
          >
            {() => (
              <Form>
                {/* Employee Name */}

                {/* Date */}
                <div className="mb-3">
                  <label className="form-label">
                    Date <span className="text-danger">*</span>
                  </label>
                  <Field type="date" name="date" className="form-control" />
                  <ErrorMessage
                    name="date"
                    component="div"
                    className="text-danger small"
                  />
                </div>

                {/* Requested Time */}
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">
                      Requested In Time <span className="text-danger">*</span>
                    </label>
                    <Field
                      type="time"
                      name="requestedIn"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="requestedIn"
                      component="div"
                      className="text-danger small"
                    />
                  </div>
                  <div className="col">
                    <label className="form-label">
                      Requested Out Time <span className="text-danger">*</span>
                    </label>
                    <Field
                      type="time"
                      name="requestedOut"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="requestedOut"
                      component="div"
                      className="text-danger small"
                    />
                  </div>
                </div>

                {/* Reason */}
                <div className="mb-3">
                  <label className="form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <Field
                    as="textarea"
                    name="remarks"
                    rows="3"
                    className="form-control"
                    placeholder="Enter reason"
                  />
                  <ErrorMessage
                    name="remarks"
                    component="div"
                    className="text-danger small"
                  />
                </div>

                {/* Submit */}
                <button type="submit" className="btn btn-primary">
                  Submit Application
                </button>
              </Form>
            )}
          </Formik>
        </div>
      )}

      {/* Previous Applications */}
      {/* Previous Applications */}
      {activeTab === "previous" && (
        <div className="row">
          {prevApp?.map((app) => (
            <div className="col-md-6 mb-4" key={app.id}>
              <div
                className="card border-0 shadow-sm h-100"
                style={{
                  borderRadius: "15px",
                  overflow: "hidden",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 18px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(0,0,0,0.08)";
                }}
              >
                {/* Date Header */}
                <div
                  className="text-center p-3"
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <span
                    style={{
                      backgroundColor:
                        app.is_approved === "Approved"
                          ? "#d4edda"
                          : app.is_approved === "Rejected"
                            ? "#f8d7da"
                            : "#fff3cd",
                      color:
                        app.is_approved === "Approved"
                          ? "#155724"
                          : app.is_approved === "Rejected"
                            ? "#721c24"
                            : "#856404",
                      fontWeight: "600",
                      padding: "4px 10px",
                      borderRadius: "50px",
                      fontSize: "0.85rem",
                    }}
                  >
                    {app.is_approved}
                  </span>
                  <div className="fw-bold fs-5 mt-2">
                    {new Date(app.date).toLocaleDateString("en-GB")}
                  </div>
                </div>

                {/* Card Body */}
                <div className="card-body">
                  {/* <p className="mb-2">
              <strong>👤 Staff Name:</strong> {app.staff_name}
            </p> */}
                  <p className="mb-2">
                    <strong>🕒 Requested In:</strong> {app.requestedIn}
                  </p>
                  <p className="mb-2">
                    <strong>🕒 Requested Out:</strong> {app.requestedOut}
                  </p>
                  <p className="mb-0">
                    <strong>💬 Remarks:</strong> {app.remarks}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmployeeRegularize;
